<button
  mat-button
  class="commerc-service-btn"
  [attr.matTooltip]="'globalUi.commercialService.title' | translate"
  (click)="openCommercialServicePopUp()"
>
  <img alt=""
    src="assets/icons/headset.svg"
    class="commerc-service-icon"
    width="24"
    height="24"
    style="top:-2px;"
  />
</button>
